import { observer } from "mobx-react"
import React from "react"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import NavBarMobile from "./NavBar.mobile"
import NavBarDesktop from "./NavBar.desktop"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import NavBarUserDesktop from "./NavBarUser.dekstop"

export const NavBar = observer(() => {
	const { isMobile } = useScreenType()
	const store = useStore()

	if (isMobile) return <NavBarMobile />

	return store.isInAdminSection ? <NavBarDesktop /> : <NavBarUserDesktop />
})

export default NavBar
